import { render, staticRenderFns } from "./FormLabelMessage.vue?vue&type=template&id=04cfb986"
import script from "./FormLabelMessage.vue?vue&type=script&lang=js"
export * from "./FormLabelMessage.vue?vue&type=script&lang=js"
import style0 from "./FormLabelMessage.vue?vue&type=style&index=0&id=04cfb986&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports